import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import * as actions from '@returnmates/client-core/src/constants/actionTypes'
import { Package, PackageType } from '@returnmates/client-core/src/graphql/generated/api'
import { SnackBarStatuses } from '@returnmates/client-core/src/type'
import OpenLinkIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/OpenLinkIcon'
import { WILSON_URL } from '@returnmates/ui-core/src/constants/paths'
import clsx from 'clsx'
import { memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import useStyles from '../styles'

interface Props {
  packages: (Package | null)[]
}

const Packages = ({ packages }: Props) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const copyToClipboard = useCallback(
    (id: string) => () => {
      navigator.clipboard.writeText(id || '')

      dispatch(
        actions.addSnackBar.request({
          type: SnackBarStatuses.SUCCESS,
          message: `Package ID was successfully copied to the clipboard`,
        }),
      )
    },
    [dispatch],
  )

  const openPackage = useCallback(
    (id: string) => () => {
      if (typeof window !== 'undefined') {
        const trackingLink = `${WILSON_URL}/packages?packageId=${id}`
        window.open(trackingLink, '_blank')?.focus()
      }
    },
    [],
  )

  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.headerRow}>
          <TableCell className={classes.headerCell}>Package ID</TableCell>
          <TableCell className={classes.headerCell}>Type</TableCell>
          <TableCell className={classes.headerCell}>Status</TableCell>
          <TableCell className={classes.headerCell}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {packages?.map(pkg => (
          <TableRow key={pkg?.id} className={classes.tableRow}>
            <TableCell
              onClick={copyToClipboard(pkg?.id || '')}
              className={clsx(classes.bodyCell, classes.packageIdCell)}
            >
              {pkg?.id}
            </TableCell>
            <TableCell className={classes.bodyCell}>
              {pkg?.type === PackageType.DROPOFF ? 'DELIVERY' : 'PICKUP'}
            </TableCell>
            <TableCell className={clsx(classes.bodyCell, classes.upperCaseText)}>
              {pkg?.status}
            </TableCell>
            <TableCell
              onClick={openPackage(pkg?.id || '')}
              className={clsx(classes.bodyCell, classes.openLinkCell)}
            >
              <OpenLinkIcon />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
export default memo(Packages)
